export const ACTION = {
    GET_CASH_COMPONENT: 'GET_CASH_COMPONENT',
    GET_CASH_DATA: 'GET_CASH_DATA',
    GET_REBALANCING_DATA: 'GET_REBALANCING_DATA',
    GET_REBALANCING_DATAWISE: 'GET_REBALANCING_DATAWISE',
};
